'use strict';
const regex = '[\uD800-\uDBFF][\uDC00-\uDFFF]';

module.exports = opts => opts && opts.exact ? new RegExp(`^${regex}$`) : new RegExp(regex, 'g');



//////////////////
// WEBPACK FOOTER
// ./node_modules/astral-regex/index.js
// module id = ./node_modules/astral-regex/index.js
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13